import { AsyncComponentLoader } from "vue"
import ComponentLoader from '../components/ComponentLoader.vue'
import ComponentError from '../components/ComponentError.vue'

export default (loader: AsyncComponentLoader) => {
  // return {
  //   render() {
  //     return h(defineAsyncComponent({
  //       loader,
  //       loadingComponent: ComponentLoader,
  //       errorComponent: ComponentError,
  //       delay: 200,
  //       timeout: 10000
  //     }));
  //   }
  // }
  return defineAsyncComponent({
    loader,
    loadingComponent: ComponentLoader,
    errorComponent: ComponentError,
    delay: 200,
    timeout: 10000
  })
}
